import { DataRow } from "@client/components/round/allocator/RatingTable/RatingTable";

export function importScores(
  tsvContent: string,
  existingRows: DataRow[],
): DataRow[] {
  const lines = tsvContent.split("\n").filter((line) => line.trim() !== "");
  const header = lines[0].split("\t").map((h) => h.trim());
  const evaluatorNames = header.slice(1);

  const importedData = new Map<string, Map<string, string>>();

  lines.slice(1).forEach((line) => {
    const values = line.split("\t").map((v) => v.trim());
    const orgName = values[0].replace(/"/g, "");

    if (!importedData.has(orgName)) {
      importedData.set(orgName, new Map());
    }

    evaluatorNames.forEach((evaluator, index) => {
      const rating = values[index + 1];
      importedData.get(orgName)!.set(evaluator, rating || "");
    });
  });

  return existingRows.map((row) => {
    const importedRating = importedData
      .get(row.orgName)
      ?.get(row.evaluatorName);

    return {
      ...row,
      rating: importedRating !== undefined ? importedRating : "",
    };
  });
}
